import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecificSteelProfileForm} from '../specific-steel-profile-form';
import {PurlinProfile} from '../../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';

@Component({
    selector: 'app-purlin-profile-form',
    templateUrl: './purlin-profile-form.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class PurlinProfileFormComponent implements OnInit, SpecificSteelProfileForm {
    @Input() profile: PurlinProfile;
    @Output() specificIsValid = new EventEmitter<boolean>();
    profileData: AbstractControl;

    formErrors = {
        'A': '',
        'B': '',
        'C': '',
        'e': '',
        // 'l': '',
        'qt_sa_scr_5': '',
        'qt_sa_scr_6': '',
        'qt_sa_scr_7': '',
        'qt_sa_scr_8': '',
        'qt_sa_scr_9': '',
        'qt_sa_scr_10': '',
        'qt_sa_ccr_5': '',
        'qt_sa_ccr_6': '',
        'qt_sa_ccr_7': '',
        'qt_sa_ccr_8': '',
        'qt_sa_ccr_9': '',
        'qt_sa_ccr_10': '',
        'qt_tr_scr_5': '',
        'qt_tr_scr_6': '',
        'qt_tr_scr_7': '',
        'qt_tr_scr_8': '',
        'qt_tr_scr_9': '',
        'qt_tr_scr_10': '',
        'qt_tr_ccr_5': '',
        'qt_tr_ccr_6': '',
        'qt_tr_ccr_7': '',
        'qt_tr_ccr_8': '',
        'qt_tr_ccr_9': '',
        'qt_tr_ccr_10': '',
        'qt_ex_scr_5': '',
        'qt_ex_scr_6': '',
        'qt_ex_scr_7': '',
        'qt_ex_scr_8': '',
        'qt_ex_scr_9': '',
        'qt_ex_scr_10': '',
        'qt_ex_ccr_5': '',
        'qt_ex_ccr_6': '',
        'qt_ex_ccr_7': '',
        'qt_ex_ccr_8': '',
        'qt_ex_ccr_9': '',
        'qt_ex_ccr_10': '',
        'qd_sa_5': '',
        'qd_sa_6': '',
        'qd_sa_7': '',
        'qd_sa_8': '',
        'qd_sa_9': '',
        'qd_sa_10': '',
        'qd_tr_5': '',
        'qd_tr_6': '',
        'qd_tr_7': '',
        'qd_tr_8': '',
        'qd_tr_9': '',
        'qd_tr_10': '',
        'qd_ex_5': '',
        'qd_ex_6': '',
        'qd_ex_7': '',
        'qd_ex_8': '',
        'qd_ex_9': '',
        'qd_ex_10': ''
    };

    validationMessages = {
        'A': {
            'required': 'Ingresar valor de A.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'B': {
            'required': 'Ingresar valor de B.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'C': {
            'required': 'Ingresar valor de C.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'e': {
            'required': 'Ingresar valor de e.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        // 'l': {
        //     'required': 'Ingresar valor de l.',
        //     'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        // },
        'qt_sa_scr_5': {
            'required': 'Ingresar valor de qt_sa_scr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_scr_6': {
            'required': 'Ingresar valor de qt_sa_scr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_scr_7': {
            'required': 'Ingresar valor de qt_sa_scr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_scr_8': {
            'required': 'Ingresar valor de qt_sa_scr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_scr_9': {
            'required': 'Ingresar valor de qt_sa_scr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_scr_10': {
            'required': 'Ingresar valor de qt_sa_scr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_5': {
            'required': 'Ingresar valor de qt_sa_ccr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_6': {
            'required': 'Ingresar valor de qt_sa_ccr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_7': {
            'required': 'Ingresar valor de qt_sa_ccr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_8': {
            'required': 'Ingresar valor de qt_sa_ccr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_9': {
            'required': 'Ingresar valor de qt_sa_ccr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_sa_ccr_10': {
            'required': 'Ingresar valor de qt_sa_ccr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_5': {
            'required': 'Ingresar valor de qt_tr_scr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_6': {
            'required': 'Ingresar valor de qt_tr_scr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_7': {
            'required': 'Ingresar valor de qt_tr_scr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_8': {
            'required': 'Ingresar valor de qt_tr_scr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_9': {
            'required': 'Ingresar valor de qt_tr_scr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_scr_10': {
            'required': 'Ingresar valor de qt_tr_scr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_5': {
            'required': 'Ingresar valor de qt_tr_ccr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_6': {
            'required': 'Ingresar valor de qt_tr_ccr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_7': {
            'required': 'Ingresar valor de qt_tr_ccr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_8': {
            'required': 'Ingresar valor de qt_tr_ccr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_9': {
            'required': 'Ingresar valor de qt_tr_ccr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_tr_ccr_10': {
            'required': 'Ingresar valor de qt_tr_ccr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_5': {
            'required': 'Ingresar valor de qt_ex_scr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_6': {
            'required': 'Ingresar valor de qt_ex_scr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_7': {
            'required': 'Ingresar valor de qt_ex_scr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_8': {
            'required': 'Ingresar valor de qt_ex_scr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_9': {
            'required': 'Ingresar valor de qt_ex_scr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_scr_10': {
            'required': 'Ingresar valor de qt_ex_scr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_5': {
            'required': 'Ingresar valor de qt_ex_ccr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_6': {
            'required': 'Ingresar valor de qt_ex_ccr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_7': {
            'required': 'Ingresar valor de qt_ex_ccr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_8': {
            'required': 'Ingresar valor de qt_ex_ccr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_9': {
            'required': 'Ingresar valor de qt_ex_ccr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qt_ex_ccr_10': {
            'required': 'Ingresar valor de qt_ex_ccr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_5': {
            'required': 'Ingresar valor de qd_sa_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_6': {
            'required': 'Ingresar valor de qd_sa_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_7': {
            'required': 'Ingresar valor de qd_sa_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_8': {
            'required': 'Ingresar valor de qd_sa_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_9': {
            'required': 'Ingresar valor de qd_sa_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_sa_10': {
            'required': 'Ingresar valor de qd_sa_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_5': {
            'required': 'Ingresar valor de qd_tr_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_6': {
            'required': 'Ingresar valor de qd_tr_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_7': {
            'required': 'Ingresar valor de qd_tr_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_8': {
            'required': 'Ingresar valor de qd_tr_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_9': {
            'required': 'Ingresar valor de qd_tr_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_tr_10': {
            'required': 'Ingresar valor de qd_tr_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_5': {
            'required': 'Ingresar valor de qd_ex_5.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_6': {
            'required': 'Ingresar valor de qd_ex_6.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_7': {
            'required': 'Ingresar valor de qd_ex_7.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_8': {
            'required': 'Ingresar valor de qd_ex_8.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_9': {
            'required': 'Ingresar valor de qd_ex_9.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'qd_ex_10': {
            'required': 'Ingresar valor de qd_ex_10.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
    };

    constructor(private fb: FormBuilder) {
        this.profileData = this.fb.group({
            A: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            B: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            C: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            e: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            // l: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_scr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_sa_ccr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_scr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_tr_ccr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_scr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qt_ex_ccr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_sa_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_tr_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_5: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_6: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_7: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_8: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_9: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
            qd_ex_10: [null, null], // [Validators.required, CintacValidators.positiveFloatValidator()]],
        });
    }

    ngOnInit() {
        this.profileData.reset({
            A: this.profile.A,
            B: this.profile.B,
            C: this.profile.C,
            e: this.profile.e,
            // l: this.profile.l,
            qt_sa_scr_5: this.profile.qt_sa_scr_5,
            qt_sa_scr_6: this.profile.qt_sa_scr_6,
            qt_sa_scr_7: this.profile.qt_sa_scr_7,
            qt_sa_scr_8: this.profile.qt_sa_scr_8,
            qt_sa_scr_9: this.profile.qt_sa_scr_9,
            qt_sa_scr_10: this.profile.qt_sa_scr_10,
            qt_sa_ccr_5: this.profile.qt_sa_ccr_5,
            qt_sa_ccr_6: this.profile.qt_sa_ccr_6,
            qt_sa_ccr_7: this.profile.qt_sa_ccr_7,
            qt_sa_ccr_8: this.profile.qt_sa_ccr_8,
            qt_sa_ccr_9: this.profile.qt_sa_ccr_9,
            qt_sa_ccr_10: this.profile.qt_sa_ccr_10,
            qt_tr_scr_5: this.profile.qt_tr_scr_5,
            qt_tr_scr_6: this.profile.qt_tr_scr_6,
            qt_tr_scr_7: this.profile.qt_tr_scr_7,
            qt_tr_scr_8: this.profile.qt_tr_scr_8,
            qt_tr_scr_9: this.profile.qt_tr_scr_9,
            qt_tr_scr_10: this.profile.qt_tr_scr_10,
            qt_tr_ccr_5: this.profile.qt_tr_ccr_5,
            qt_tr_ccr_6: this.profile.qt_tr_ccr_6,
            qt_tr_ccr_7: this.profile.qt_tr_ccr_7,
            qt_tr_ccr_8: this.profile.qt_tr_ccr_8,
            qt_tr_ccr_9: this.profile.qt_tr_ccr_9,
            qt_tr_ccr_10: this.profile.qt_tr_ccr_10,
            qt_ex_scr_5: this.profile.qt_ex_scr_5,
            qt_ex_scr_6: this.profile.qt_ex_scr_6,
            qt_ex_scr_7: this.profile.qt_ex_scr_7,
            qt_ex_scr_8: this.profile.qt_ex_scr_8,
            qt_ex_scr_9: this.profile.qt_ex_scr_9,
            qt_ex_scr_10: this.profile.qt_ex_scr_10,
            qt_ex_ccr_5: this.profile.qt_ex_ccr_5,
            qt_ex_ccr_6: this.profile.qt_ex_ccr_6,
            qt_ex_ccr_7: this.profile.qt_ex_ccr_7,
            qt_ex_ccr_8: this.profile.qt_ex_ccr_8,
            qt_ex_ccr_9: this.profile.qt_ex_ccr_9,
            qt_ex_ccr_10: this.profile.qt_ex_ccr_10,
            qd_sa_5: this.profile.qd_sa_5,
            qd_sa_6: this.profile.qd_sa_6,
            qd_sa_7: this.profile.qd_sa_7,
            qd_sa_8: this.profile.qd_sa_8,
            qd_sa_9: this.profile.qd_sa_9,
            qd_sa_10: this.profile.qd_sa_10,
            qd_tr_5: this.profile.qd_tr_5,
            qd_tr_6: this.profile.qd_tr_6,
            qd_tr_7: this.profile.qd_tr_7,
            qd_tr_8: this.profile.qd_tr_8,
            qd_tr_9: this.profile.qd_tr_9,
            qd_tr_10: this.profile.qd_tr_10,
            qd_ex_5: this.profile.qd_ex_5,
            qd_ex_6: this.profile.qd_ex_6,
            qd_ex_7: this.profile.qd_ex_7,
            qd_ex_8: this.profile.qd_ex_8,
            qd_ex_9: this.profile.qd_ex_9,
            qd_ex_10: this.profile.qd_ex_10,
        });
        this.profileData.valueChanges.subscribe(values => this.onValueChanged());
    }

    private onValueChanged() {
        const form = this.profileData;
        this.updateProfile();
        Object.keys(this.formErrors).forEach(field => {
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        this.formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
        this.specificIsValid.emit(this.profileData.valid);
    }

    updateProfile() {
        this.profile.A = this.profileData.value.A;
        this.profile.B = this.profileData.value.B;
        this.profile.C = this.profileData.value.C;
        this.profile.e = this.profileData.value.e;
        // this.profile.l = this.profileData.value.l;
        this.profile.qt_sa_scr_5 = this.profileData.value.qt_sa_scr_5;
        this.profile.qt_sa_scr_6 = this.profileData.value.qt_sa_scr_6;
        this.profile.qt_sa_scr_7 = this.profileData.value.qt_sa_scr_7;
        this.profile.qt_sa_scr_8 = this.profileData.value.qt_sa_scr_8;
        this.profile.qt_sa_scr_9 = this.profileData.value.qt_sa_scr_9;
        this.profile.qt_sa_scr_10 = this.profileData.value.qt_sa_scr_10;
        this.profile.qt_sa_ccr_5 = this.profileData.value.qt_sa_ccr_5;
        this.profile.qt_sa_ccr_6 = this.profileData.value.qt_sa_ccr_6;
        this.profile.qt_sa_ccr_7 = this.profileData.value.qt_sa_ccr_7;
        this.profile.qt_sa_ccr_8 = this.profileData.value.qt_sa_ccr_8;
        this.profile.qt_sa_ccr_9 = this.profileData.value.qt_sa_ccr_9;
        this.profile.qt_sa_ccr_10 = this.profileData.value.qt_sa_ccr_10;
        this.profile.qt_tr_scr_5 = this.profileData.value.qt_tr_scr_5;
        this.profile.qt_tr_scr_6 = this.profileData.value.qt_tr_scr_6;
        this.profile.qt_tr_scr_7 = this.profileData.value.qt_tr_scr_7;
        this.profile.qt_tr_scr_8 = this.profileData.value.qt_tr_scr_8;
        this.profile.qt_tr_scr_9 = this.profileData.value.qt_tr_scr_9;
        this.profile.qt_tr_scr_10 = this.profileData.value.qt_tr_scr_10;
        this.profile.qt_tr_ccr_5 = this.profileData.value.qt_tr_ccr_5;
        this.profile.qt_tr_ccr_6 = this.profileData.value.qt_tr_ccr_6;
        this.profile.qt_tr_ccr_7 = this.profileData.value.qt_tr_ccr_7;
        this.profile.qt_tr_ccr_8 = this.profileData.value.qt_tr_ccr_8;
        this.profile.qt_tr_ccr_9 = this.profileData.value.qt_tr_ccr_9;
        this.profile.qt_tr_ccr_10 = this.profileData.value.qt_tr_ccr_10;
        this.profile.qt_ex_scr_5 = this.profileData.value.qt_ex_scr_5;
        this.profile.qt_ex_scr_6 = this.profileData.value.qt_ex_scr_6;
        this.profile.qt_ex_scr_7 = this.profileData.value.qt_ex_scr_7;
        this.profile.qt_ex_scr_8 = this.profileData.value.qt_ex_scr_8;
        this.profile.qt_ex_scr_9 = this.profileData.value.qt_ex_scr_9;
        this.profile.qt_ex_scr_10 = this.profileData.value.qt_ex_scr_10;
        this.profile.qt_ex_ccr_5 = this.profileData.value.qt_ex_ccr_5;
        this.profile.qt_ex_ccr_6 = this.profileData.value.qt_ex_ccr_6;
        this.profile.qt_ex_ccr_7 = this.profileData.value.qt_ex_ccr_7;
        this.profile.qt_ex_ccr_8 = this.profileData.value.qt_ex_ccr_8;
        this.profile.qt_ex_ccr_9 = this.profileData.value.qt_ex_ccr_9;
        this.profile.qt_ex_ccr_10 = this.profileData.value.qt_ex_ccr_10;
        this.profile.qd_sa_5 = this.profileData.value.qd_sa_5;
        this.profile.qd_sa_6 = this.profileData.value.qd_sa_6;
        this.profile.qd_sa_7 = this.profileData.value.qd_sa_7;
        this.profile.qd_sa_8 = this.profileData.value.qd_sa_8;
        this.profile.qd_sa_9 = this.profileData.value.qd_sa_9;
        this.profile.qd_sa_10 = this.profileData.value.qd_sa_10;
        this.profile.qd_tr_5 = this.profileData.value.qd_tr_5;
        this.profile.qd_tr_6 = this.profileData.value.qd_tr_6;
        this.profile.qd_tr_7 = this.profileData.value.qd_tr_7;
        this.profile.qd_tr_8 = this.profileData.value.qd_tr_8;
        this.profile.qd_tr_9 = this.profileData.value.qd_tr_9;
        this.profile.qd_tr_10 = this.profileData.value.qd_tr_10;
        this.profile.qd_ex_5 = this.profileData.value.qd_ex_5;
        this.profile.qd_ex_6 = this.profileData.value.qd_ex_6;
        this.profile.qd_ex_7 = this.profileData.value.qd_ex_7;
        this.profile.qd_ex_8 = this.profileData.value.qd_ex_8;
        this.profile.qd_ex_9 = this.profileData.value.qd_ex_9;
        this.profile.qd_ex_10 = this.profileData.value.qd_ex_10;
    }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/purlin-profile-form/purlin-profile-form.component.ts